
import { computed, defineComponent, PropType } from 'vue'

// components
import Cheap from '@/common/components/UI/Cheap/index.vue'
import NewButton from '@/ui-kit/NewButton/index.vue'

// constants
import { TRIPS_STATUSES } from '@/core/constants/tms.constants'

import { formatDateWithTimeFromBackend, formatDateFromBackend } from '@/common/helpers/formatDate'

export default defineComponent({
    props: {
        row: {
            type: Object as PropType<any>,
            default: null,
        },
        column: {
            type: Object as PropType<any>,
            default: null,
        },
        index: {
            type: Number,
            required: true,
        },
    },
    components: { Cheap, NewButton },
    emits: ['update'],
    setup(props, { emit }) {
        const onUpdate = () => {
            emit('update', { ttnId: props.row.id, expectedDate: props.row.expectedDate })
        }

        const getCheapTitle = computed(() => {
            return props.row && props.row.isDelayed ? 'Опаздывает' : props.row.status.name
        })

        const getCheapClass = computed(() => {
            let className = 'small w-min '

            if (props.row && props.row.isDelayed) {
                className += 'red'
            } else if (props.row && props.row.status) {
                className += TRIPS_STATUSES[props.row.status.id - 1]
            }

            return className
        })

        const isDirection = computed(() => {
            return (
                props.column &&
                props.row &&
                props.column.key === 'direction' &&
                props.row.fromCity &&
                props.row.toCity
            )
        })

        return {
            onUpdate,
            getCheapTitle,
            getCheapClass,
            isDirection,
            //
            TRIPS_STATUSES,
            formatDateWithTimeFromBackend,
            formatDateFromBackend
        }
    },
})
